<template>
  <div
    :id="modalId"
    class="modal fade"
    tabindex="-1"
    :aria-labelledby="modalId + 'Label'"
    aria-hidden="true"
  >
    <div class="modal-dialog" :class="modalSizeClass">
      <div class="modal-content">
        <!-- Header -->
        <div v-if="!hideHeader" class="modal-header">
          <h5 :id="modalId + 'Label'" class="modal-title">
            <slot name="header">{{ title }}</slot>
          </h5>
          <button
            v-if="!hideCloseButton"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleClose"
          ></button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <slot></slot>
        </div>

        <!-- Footer -->
        <div v-if="!hideFooter" class="modal-footer">
          <slot name="footer">
            <button
              v-if="!hideCancelButton"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="handleCancel"
            >
              {{ cancelButtonText }}
            </button>
            <button
              v-if="!hideSubmitButton"
              type="button"
              class="btn btn-primary"
              :disabled="submitDisabled"
              @click="handleSubmit"
            >
              {{ submitButtonText }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Modal } from 'bootstrap';

export default {
  name: 'ModalBase',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validator: (value: string): boolean => ['sm', 'md', 'lg', 'xl'].includes(value),
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    hideCancelButton: {
      type: Boolean,
      default: false,
    },
    hideSubmitButton: {
      type: Boolean,
      default: false,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
    submitButtonText: {
      type: String,
      default: 'Submit',
    },
  },

  data(): {
    modalInstance: Modal | null;
  } {
    return {
      modalInstance: null,
    };
  },

  computed: {
    modalSizeClass(): string {
      return this.size !== 'md' ? `modal-${this.size}` : '';
    },
  },

  mounted(): void {
    this.modalInstance = new Modal(document.getElementById(this.modalId));
  },

  methods: {
    show(): void {
      this.modalInstance.show();
    },
    hide(): void {
      this.modalInstance.hide();
    },
    handleClose(): void {
      this.$emit('close');
    },
    handleCancel(): void {
      this.$emit('cancel');
    },
    handleSubmit(): void {
      this.$emit('submit');
    },
  },
};
</script>
